/**
 * Normalize API responses into an array.
 * Handles shapes like: array, { items: [] }, { results: [] }, { data: [] }, { all_time: { entries: [] } }
 */
export function normalizeToArray<T = any>(raw: any): T[] {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw as T[];
  if (raw && Array.isArray((raw as any).items)) return (raw as any).items as T[];
  if (raw && Array.isArray((raw as any).results)) return (raw as any).results as T[];
  if (raw && raw.all_time && Array.isArray(raw.all_time.entries)) return raw.all_time.entries as T[];
  if (raw && Array.isArray((raw as any).data)) return (raw as any).data as T[];
  return [];
}

export default normalizeToArray;
